// 再刷新页面的时候去监听当前路由然后更新 currentIndex
function amendCurrentPath(routes) {
    let currentPath = this.$route.path
    routes.forEach((item, index) => {
        if (item.router == currentPath) {
            this.currentIndex = index
        }
    });
}
// 倒计时
function countDownFunc(time) {
    let maxtime = 60 * time - 1,
        counttimer = () => {
            if (maxtime >= 0) {
                let minutes = Math.floor(maxtime / 60),
                    seconds = Math.floor(maxtime % 60),
                    msg = `0时${minutes}分${seconds}秒`;
                --maxtime;
                this.countDown = msg;
            } else {
                clearInterval(this.timer);
                this.countDown = '0时00分00秒';
            }
        };
    this.timer = setInterval(counttimer, 1000);
}

// 格式化时间
function formatTimer(date = 0, fmt = 'yyyy-MM-dd') {
    if (!date) {
        return ""
    }
    // yyyy - MM - dd hh: mm: ss
    date = new Date(+date)
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let obj = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    for (let key in obj) {
        if (new RegExp(`(${key})`).test(fmt)) {
            let str = obj[key] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
        }
    }
    return fmt;
}

// 消息提示
function messageAlert(message, type, duration = 1700) {
    let messageObj = {
        s: 'success',
        w: 'warning'
    }
    this.$message({
        message: message,
        type: messageObj[type],
        showClose: true,
        offset: 100,
        duration: duration,
    });
}

export {
    amendCurrentPath,
    countDownFunc,
    formatTimer,
    messageAlert
}


// WEBPACK FOOTER //
// ./src/mixins/methods/common.js